<template>
  <div>
    <el-collapse id="faq">
      <el-collapse-item :title="$t('promotion.fundsGrowthPromotion.faq.q1')" name="q1">
        <div class="mb-3">{{ $t('promotion.fundsGrowthPromotion.faq.a1') }}</div>
      </el-collapse-item>
      <el-collapse-item :title="$t('promotion.fundsGrowthPromotion.faq.q2')" name="q2">
        <div class="mb-3">{{ $t('promotion.fundsGrowthPromotion.faq.a2') }}</div>
      </el-collapse-item>
      <el-collapse-item :title="$t('promotion.fundsGrowthPromotion.faq.q3')" name="q3">
        <div class="mb-3">{{ $t('promotion.fundsGrowthPromotion.faq.a3_1') }}</div>
        <div class="mb-3">{{ $t('promotion.fundsGrowthPromotion.faq.a3_2') }}</div>
      </el-collapse-item>
      <el-collapse-item :title="$t('promotion.fundsGrowthPromotion.faq.q4')" name="q4">
        <div class="mb-4">{{ $t('promotion.fundsGrowthPromotion.faq.a4_1') }}</div>
        <div class="mb-4">{{ $t('promotion.fundsGrowthPromotion.faq.a4_2') }}</div>
        <div class="mb-4">{{ $t('promotion.fundsGrowthPromotion.faq.a4_3') }}</div>
        <div class="mb-4">{{ $t('promotion.fundsGrowthPromotion.faq.a4_4') }}</div>
        <div class="mb-3">{{ $t('promotion.fundsGrowthPromotion.faq.a4_5') }}</div>
        <!-- <div class="mb-3 bold-text">
          {{ $t('promotion.fundsGrowthPromotion.faq.table.dailyInterest') }}: <span class="primary-text">0.05%</span>
        </div> -->
        <el-table :data="tableData" border :span-method="arraySpanMethod" :cell-style="setCellStyle" class="mb-3">
          <el-table-column prop="1" :label="$t('promotion.fundsGrowthPromotion.faq.table.day')" min-width="100">
          </el-table-column>
          <el-table-column
            prop="2"
            :label="$t('promotion.fundsGrowthPromotion.faq.table.eligibleFunds')"
            min-width="100"
          >
          </el-table-column>
          <el-table-column prop="3" :label="$t('promotion.fundsGrowthPromotion.faq.table.eligibility')" min-width="100">
          </el-table-column>
          <el-table-column :label="$t('promotion.fundsGrowthPromotion.faq.table.lotsTraded')" min-width="100">
            <el-table-column prop="4" label="1" min-width="100"> </el-table-column>
            <el-table-column prop="5" label="2" min-width="100"> </el-table-column>
            <el-table-column prop="6" label="3" min-width="100"> </el-table-column>
            <el-table-column prop="7" label="4" min-width="100"> </el-table-column>
            <el-table-column prop="8" label="5" min-width="100"> </el-table-column>
            <el-table-column prop="9" label="6" min-width="100"> </el-table-column>
          </el-table-column>
        </el-table>
      </el-collapse-item>
      <el-collapse-item :title="$t('promotion.fundsGrowthPromotion.faq.q5')" name="q5">
        <div class="mb-2">{{ $t('promotion.fundsGrowthPromotion.faq.a5') }}</div>
        <ul class="mb-2 ltr:ml-6 rtl:mr-6">
          <li>
            {{ $t('promotion.fundsGrowthPromotion.faq.a5_1') }}
            <ol class="my-3 ltr:ml-6 rtl:mr-6">
              <li>{{ $t('promotion.fundsGrowthPromotion.faq.a5_1_1') }}</li>
              <li>{{ $t('promotion.fundsGrowthPromotion.faq.a5_1_2') }}</li>
              <li>{{ $t('promotion.fundsGrowthPromotion.faq.a5_1_3') }}</li>
            </ol>
          </li>
          <li>{{ $t('promotion.fundsGrowthPromotion.faq.a5_2') }}</li>
          <li>{{ $t('promotion.fundsGrowthPromotion.faq.a5_3') }}</li>
        </ul>
        <div>{{ $t('promotion.fundsGrowthPromotion.faq.contactUs') }}</div>
      </el-collapse-item>
      <el-collapse-item :title="$t('promotion.fundsGrowthPromotion.faq.q6')" name="q6">
        <div class="mb-2">{{ $t('promotion.fundsGrowthPromotion.faq.a6') }}</div>
        <ul class="mb-2 ltr:ml-6 rtl:mr-6">
          <li>
            {{ $t('promotion.fundsGrowthPromotion.faq.a6_1') }}
          </li>
          <li>{{ $t('promotion.fundsGrowthPromotion.faq.a6_2') }}</li>
          <li>{{ $t('promotion.fundsGrowthPromotion.faq.a6_3') }}</li>
        </ul>
        <div>{{ $t('promotion.fundsGrowthPromotion.faq.contactUs') }}</div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import Accordion from '../promotion/Accordion.vue';

export default {
  name: 'Faq',
  components: {
    Accordion
  },
  data() {
    const repeatedData = {
      4: '$ 2.5',
      5: '$ 5',
      6: '$ 7.5',
      7: '$ 9',
      8: '$ 9',
      9: '$ 9'
    };
    return {
      tableData: [
        {
          1: this.$t('promotion.fundsGrowthPromotion.faq.table.1'),
          2: '$ 18,000',
          3: this.$t('promotion.fundsGrowthPromotion.faq.table.yes'),
          ...repeatedData
        },
        {
          1: this.$t('promotion.fundsGrowthPromotion.faq.table.2'),
          2: '$ 18,000',
          3: this.$t('promotion.fundsGrowthPromotion.faq.table.yes'),
          ...repeatedData
        },
        {
          1: this.$t('promotion.fundsGrowthPromotion.faq.table.3'),
          2: '$ 18,000',
          3: this.$t('promotion.fundsGrowthPromotion.faq.table.yes'),
          ...repeatedData
        },
        {
          1: this.$t('promotion.fundsGrowthPromotion.faq.table.4'),
          2: '$ 18,000',
          3: this.$t('promotion.fundsGrowthPromotion.faq.table.yes'),
          ...repeatedData
        },
        {
          1: this.$t('promotion.fundsGrowthPromotion.faq.table.5'),
          2: '$ 18,000',
          3: this.$t('promotion.fundsGrowthPromotion.faq.table.yes'),
          ...repeatedData
        },
        {
          1: this.$t('promotion.fundsGrowthPromotion.faq.table.total'),
          2: '$ 12.50',
          3: '$ 25.00',
          4: '$ 37.50',
          5: '$ 45.00',
          6: '$ 45.00',
          7: '$ 45.00'
        }
      ]
    };
  },
  methods: {
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 5 && columnIndex === 0) {
        return {
          rowspan: 1,
          colspan: 3
        };
      }
    },
    setCellStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 5 && columnIndex === 0) {
        return { backgroundColor: '#f2f6fc' };
      }
      if ((rowIndex <= 3 && columnIndex === 4) || (rowIndex === 5 && columnIndex === 2)) {
        return { color: '#0051ff', fontWeight: '600' };
      }
      if (rowIndex === 4) {
        if (columnIndex === 4) return { color: '#0051ff', fontWeight: '600', borderBottom: '1px solid #0051ff' };
        else return { borderBottom: '1px solid #0051ff' };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/fundsGrowthPromotion/faq.scss';
</style>
